define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/shelf-service/1.0.0/index',
  'readingiq-src/js/riq-js/riq-api-service/1.0.0/index'
  /* eslint-enable */
], function riqListenerInvalidateCacheModule(app, aoflModules) {
  'use strict';
  var storeService = aoflModules.store;
  var apiRequest = aoflModules.apiRequest;

  app.registerComponent('riqListenerInvalidateCache', {
    require: {},
    bindings: {},
    controller: 'riqListenerInvalidateCacheController'
  });
  app.registerController('riqListenerInvalidateCacheController', [
    'shelfService',
    '$rootScope',
    '$window',
    '$stateParams',
    '$state',
    'riqApiService',
    '$q',
    '$scope',
    function controller(
      shelfService,
      $rootScope,
      $window,
      $stateParams,
      $state,
      riqApiService,
      $q,
      $scope
    ) {
      // TODO: Fetch from server.
      var invalidate = [
        '62', // recent
        '88', // teacher_assigned
        '23', // favorites
        '24', // completed
        '74', // SWYK
        '122', // Assessed Level
        '131' // Assessed Level at School
      ];

      var _this = this;
      _this._activeReadingLevelType = '';
      _this._activeReadingLevel = [];
      _this._profileUuid = -1;

      /**
       * Clears all of the session cache.
       */
      var _clearCache = function _clearCache() {
        var cacheManager = apiRequest.getCacheManager('default');
        if (cacheManager) {
          cacheManager.clear();
        }
      };

      /**
       * _checkStoreDidChange
       * @private
       *
       * @description Invalidate cache when:
       *    - changing user
       *    - reading book
       *    - favoriting book
       *    - changing level/guide/lexile
       *
       * @param {function} onInitCB Invoked on initialization.
       */
      var _checkStoreDidChange = function _checkStoreDidChange(onInitCB) {
        var state = storeService.getState();
        onInitCB = typeof onInitCB === 'function' ? onInitCB : function() {};

        var newProfileUuid = state.profile && state.profile.profileUuid;
        var newActiveReadingLevelType =
          state.profile &&
          state.profile.profileDetails &&
          state.profile.profileDetails.activeReadingLevelType;
        var newActiveReadingLevel =
          state.profile &&
          state.profile.profileDetails &&
          state.profile.profileDetails.activeReadingLevel;
        var isLevelTypeDirty =
          newActiveReadingLevelType &&
          _this._activeReadingLevelType !== newActiveReadingLevelType;
        var isReadingLevelDirty =
          Array.isArray(newActiveReadingLevel) &&
          _this._activeReadingLevel.toString() !==
            newActiveReadingLevel.toString();

        if (
          newProfileUuid &&
          newActiveReadingLevel &&
          newActiveReadingLevelType &&
          !_checkStoreDidChange.isUnsub
        ) {
          _checkStoreDidChange.isUnsub = true;
          _this._profileUuid = newProfileUuid;
          _this._activeReadingLevelType = newActiveReadingLevelType;
          _this._activeReadingLevel = newActiveReadingLevel;
          onInitCB();
        }

        // Changed user
        if (newProfileUuid && _this._profileUuid !== newProfileUuid) {
          _this._profileUuid = newProfileUuid;
          _clearCache();
        }
        // Changed level/lexile/reading level
        else if (isLevelTypeDirty || isReadingLevelDirty) {
          _this._activeReadingLevel = newActiveReadingLevel;
          _this._activeReadingLevelType = newActiveReadingLevelType;
          _clearCache();
        }
      };

      _this.$onInit = function onInit() {
        _checkStoreDidChange();
      };

      var storeUnsubscribe = storeService.subscribe(function subscribe() {
        $scope.$applyAsync(_checkStoreDidChange.bind(null, storeUnsubscribe));
      });

      /**
       * _get
       * @description Fetches associated shelfIds
       * @private
       * @param {String|Numbea} bookId Id of book.
       * @return {Array} Associated shelf ids.
       */
      var _get = function _get(bookId) {
        var state = storeService.getState();
        if (state.bookShelvesContainer && state.bookShelvesContainer.map) {
          return state.bookShelvesContainer.map[bookId] || [];
        }
        return [];
      };

      /**
       * _updateUserShelves
       * @private
       * @description In addition to invalidating the book's mapped
       * shelves, we are automatically invalidating the following shelves:
       *  - Completed
       *  - Recent
       *  - Favorite
       *  - Show What You Know
       * @param {Array} invalidateList List of shelf ids to include
       * @param {Object} stateParams State params data
       * @param {String|Number} stateParams.id Book id
       * @param {String|Number} stateParams.collectionId shelf id
       */
      var _updateUserShelves = function _updateUserShelves(
        invalidateList,
        stateParams
      ) {
        var ids = []
          .concat(
            _get(stateParams.id),
            [stateParams.collectionId],
            invalidateList
          )
          .reduce(function unique(ids, id) {
            if (id && ids.indexOf(id) === -1) {
              return ids.concat([id]);
            }
            return ids;
          }, []);

        // Invalidate the collection cache
        ids.forEach(function(id) {
          shelfService.getShelfItems([id], {shelfView: true}, false);
        });
      }.bind(null, invalidate);

      /**
       * @private
       * @description Invalidate when toggling favorite
       * @param {Object} event Event data.
       */
      var _onMessage = function _onMessage(event) {
        var data = {};
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          data = {};
        }
        if (
          data.type === 'bookPlayerEvent' &&
          (data.payload.action === 'addFavoriteActivity' ||
            data.payload.action === 'removeFavoriteActivity')
        ) {
          _updateUserShelves($stateParams);
        }
      };

      $window.addEventListener('message', _onMessage);
      _this.$onDestroy = function onDestroy() {
        $window.removeEventListener('message', _onMessage);
      };

      $rootScope.$on('$stateChangeStart', function onStateChangeSuccess(
        event,
        toState,
        toStateParams,
        fromState,
        fromStateParams
      ) {
        // Assume changes when leaving the book player. Changes such as:
        // Favoriting a book or reading the book.
        if (
          fromState.name === 'book_player_en' ||
          fromState.name === 'placement_assessment_en' ||
          fromState.name === 'comprehension_check_en'
        ) {
          _updateUserShelves(fromStateParams);
          // Check if the user changed the following:
          // - guided level
          // - lexile level
          // - grade level
          // - user (in my account, change profile, or class login)
        } else if (
          fromState.name === 'level_en' ||
          fromState.name === 'my_account_en' ||
          fromState.name === 'change_profile_en' ||
          fromState.name === 'class_login_en'
        ) {
          _checkStoreDidChange();
        }
      });
    }
  ]);
});
